module.exports = __webpack_public_path__ + "assets/icon-list-exclamation-component.0b88aeab.svg";